import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CAREERS } from "@/components/vss/data";

/* The candidate side of the site (owner, 2026-09-28).
 *
 * Everything above this section speaks to employers. This is the one band that speaks to candidates, and both buttons leave for
 * the TalentOS careers portal: open roles, and the India registration page that already asks for notice period and expected
 * compensation in lakhs. No form lives here — a second form would mean a second candidate database, which is the thing being
 * avoided. It sits below About and above Contact so the client path reaches Request Talent first.
 */
export default function TalentNetwork() {
  return (
    <section id="talent-network" className="relative py-24 sm:py-28" data-testid="talent-network-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.21, 0.47, 0.32, 0.98] }}
          className="rounded-3xl border border-slate-200 bg-gradient-to-br from-white to-teal-50/40 px-6 py-12 sm:px-12 sm:py-14 shadow-[0_18px_44px_rgba(15,23,42,0.06)]"
        >
          <div className="font-mono-a text-[11px] uppercase tracking-[0.28em] text-teal-700">For candidates</div>

          <h2 className="mt-4 text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 max-w-[22ch]">
            Looking for your next opportunity?
          </h2>

          <p className="mt-5 text-slate-600 leading-relaxed max-w-[62ch]">
            Join Visionary&rsquo;s Talent Network and let our recruiting team consider you for current and future technology
            opportunities across India.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href={CAREERS.portal}
              data-testid="talent-network-view-jobs"
              className="group inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold bg-gradient-to-r from-cyan-500 via-teal-500 to-emerald-500 text-white hover:brightness-110 transition shadow-[0_6px_18px_rgba(20,184,166,0.28)]"
            >
              View Open Jobs
              <ArrowUpRight className="h-4 w-4 transition group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
            <a
              href={CAREERS.register}
              data-testid="talent-network-join"
              className="inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold border border-teal-600/40 text-teal-700 hover:bg-teal-50 transition"
            >
              Join Our Talent Network
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
